/**
 * Helper for using md-virtual-repeat with a list of TMR Resources.
 *
 * @example
 * let scroller = new TmrInfiniteScrollResources(TmrResource, { params... });
 *
 * @alias TmrInfiniteScrollResources
 * @type {ngFactory}
 */
function TmrInfiniteScrollResourcesFactory($timeout, tmrDefaultPagingParams) {
  'ngInject'
  return class TmrInfiniteScrollResources {
    /**
     * @param {TmrResource} TmrResource
     * @param {object} params
     * @param {number} pageSize
     * @param {string} searchAction
     * @param {string|function} countAction
     */
    constructor(
      TmrResource,
      params,
      pageSize = tmrDefaultPagingParams.limit,
      searchAction = 'query',
      countAction = 'count'
    ) {
      Object.assign(this, {
        TmrResource,
        params,
        pageSize,
        searchAction,
        pages: {},
        count: 0,
      })
      if (typeof countAction === 'string')
        TmrResource[countAction](params).then(count => (this.count = count))
      else this.count = countAction()
    }

    getItemAtIndex(index) {
      let page = Math.floor(index / this.pageSize)
      let pageIndex = index % this.pageSize
      if (this.pages[page] && this.pages[page][pageIndex])
        return this.pages[page][pageIndex]
      if (this.pages[page] === undefined) this.fetchPage(page)
    }

    fetchPage(page) {
      this.pages[page] = null
      let params = Object.assign(
        { limit: this.pageSize, offset: page * this.pageSize },
        this.params
      )
      return this.TmrResource[this.searchAction](params).$promise.then(
        resources => this.fetchPageSuccess(page, resources)
      )
    }

    fetchPageSuccess(page, resources) {
      return $timeout(() => (this.pages[page] = resources))
    }

    getLength() {
      return this.count
    }
  }
}

export const factory = [
  'TmrInfiniteScrollResources',
  TmrInfiniteScrollResourcesFactory,
]
